import { isValidPostalCode, validateUrl } from '@Utils';
import { KNOCK_EMAIL_STATUS } from './PropertiesDialog/CreateProperty/constants';

export const removeSpacesAndSymbols = (value) => value.replace(/[^\w]/g, '');

export const validatePropertyCreationPayload = (
  data,
  relayProcessingStatus = ''
) => {
  const errors = {};

  if (!data.propertyName) {
    errors.propertyName = '*required';
  }

  if (!data.propertyAddress) {
    errors.propertyAddress = '*required';
  }

  if (!data.propertyCity) {
    errors.propertyCity = '*required';
  }

  if (!data.propertyState) {
    errors.propertyState = '*required';
  }

  if (!data.propertyZip) {
    errors.propertyZip = '*required';
  } else if (!isValidPostalCode(data.propertyZip)) {
    errors.propertyZip = 'Not a valid US or Canada zip';
  }

  if (!data.propertyOwner) {
    errors.propertyOwner = '*required';
  }

  if (!data.knockEmail) {
    errors.knockEmail = '*required';
  } else if (relayProcessingStatus !== KNOCK_EMAIL_STATUS.SUCCESS) {
    errors.knockEmail = 'Check for availability required';
  }

  if (data.propertyWebsite && !validateUrl(data.propertyWebsite)) {
    errors.propertyWebsite = 'Not a valid URL';
  }

  return errors;
};
